export default __webpack_public_path__ + "static/media/heal-glyph.6504ec3b.png";